import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de1493e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "grid-item" }
const _hoisted_3 = { class: "top-content" }
const _hoisted_4 = { style: {"padding-bottom":"0.4rem"} }
const _hoisted_5 = {
  title: "Select a date for confirmed ledger tranfers",
  class: "search-with-button"
}
const _hoisted_6 = {
  class: "date-picker",
  style: {"width":"50%"}
}
const _hoisted_7 = ["disabled"]

import { computed, onMounted, ref, Ref } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "@/components/Popup.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { CurrencySymbol, MarketCurrency, MarketSelection } from "@/services/helpers/Helper";
import IBankTransferPayments from "@/Interfaces/Ledgering/IBankTransferPayments";
import { marketSelection } from "@/services/helpers/Helper";
import IBankTransferApproveOrConfirm from "@/Interfaces/Ledgering/IBankTransferApproveOrConfirm";
import { authService } from "@/auth/authSingleton";
import { approveBankTransferPayment, confirmBankTransferPayment } from "@/services/network";
import DateIgnoreTime from "@/types/DateIgnoreTime";

enum tabs {
    WAITING = "WAITING",
    CONFIRMED = "CONFIRMED",
    COMPLETED = "COMPLETED",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferPopUp',
  props: {
    modelValue: {},
    currentTab: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

onMounted(()=>{
    userEmail.value =  authService.getEmailAddress();
})

const totalDiff = ref<number>(0);
const transferFrom = ref("");
const transferTo = ref("");
const currencyUsed = ref(MarketCurrency.GB);
const line1Text = ref("");
const line2Text = ref("");
const userEmail = ref("");
const working = ref(false);
const selectedDate: Ref<Date | undefined> = ref(undefined);
const textInputOptions = ref({ format: "yyyy/MM/dd" });
const today: Date = new Date();
const maxDate: Date = new Date(today);
maxDate.setDate(today.getDate() + 1);

const props = __props;
const emits = __emit;
const bankTransferData = computed({
    get() {
        totalDiff.value = props.modelValue?.Amount? props.modelValue?.Amount : 0;
        transferFrom.value = props.modelValue?.AccountFrom? props.modelValue?.AccountFrom : "";
        transferTo.value = props.modelValue?.AccountTo? props.modelValue?.AccountTo : "";
        currencyUsed.value = GetCurrency(props.modelValue?.Market);
        return props.modelValue;
    },
    set(val) {
        emits("update:modelValue");
    },
});
const popUpTitle = computed(()=>{
    if(props.currentTab == tabs.WAITING){
        line1Text.value = "Please confirm transfer."
        line2Text.value = "Select bank transfer confirmation date:"
        return "Transfer Confirmation"
    }else{
        line1Text.value = "Please approve transfer."
        line2Text.value = "Select bank transfer approval date:"
        return "Transfer Approval"
    }
});

async function ConfirmButtonAction() {   
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try{
        let transferId = bankTransferData?.value?.TransferId
        if (transferId == null) throw new ReferenceError('selectedRow has no valid transfer Id');
        if(selectedDate.value == undefined) throw new ReferenceError('there is no valid selected date');
        if(props.currentTab == undefined) throw new ReferenceError("No confirmation or approval action was selected")
        const payload: IBankTransferApproveOrConfirm = ({
            UserEmail: userEmail.value, 
            BankTransferId: transferId, 
            UserActioned: new DateIgnoreTime(selectedDate.value)
        })
        props.currentTab == tabs.WAITING
        ? await confirmBankTransferPayment.post(payload)
        : await approveBankTransferPayment.post(payload)
        useNotifierWithErrFormatter().success({ msg: props.currentTab == tabs.WAITING? "Payment confirmed." : "Payment approved." });
    }catch (error) {
        useNotifierWithErrFormatter().error({
            name: `Transfer Payment ${props.currentTab == tabs.WAITING? 'Confirmation' : 'Approval'}`,
            errorType: `Error when ${props.currentTab == tabs.WAITING? 'confirming' : 'approving'} transfer payment`,
            error
        });
    } finally {
        closeSpinner();
        emits("confirm");
        bankTransferData.value = undefined;
        working.value = false;
    }
}
function closeChild() {
    clearEntries();
    emits("update:modelValue");
}
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
function clearEntries() {
    selectedDate.value = undefined;
}
function GetCurrency(market: keyof typeof marketSelection | undefined){
    return(market != undefined && market != null )? CurrencySymbol[MarketCurrency[market]] :  CurrencySymbol[MarketCurrency['GBP']]
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!bankTransferData.value,
    title: popUpTitle.value,
    hasClose: "",
    onClose: closeChild
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(line1Text.value), 1),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" A sum of "),
        _createElementVNode("strong", null, _toDisplayString(currencyUsed.value+Math.abs(totalDiff.value)?.toFixed(2)), 1),
        _createTextVNode(" is being transfered from account "),
        _createElementVNode("strong", null, _toDisplayString(transferFrom.value), 1),
        _createTextVNode(" to account "),
        _createElementVNode("strong", null, _toDisplayString(transferTo.value), 1),
        _createTextVNode(". ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(line2Text.value), 1),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(DatePicker), {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
              type: "date",
              "enable-time-picker": false,
              placeholder: "Select Date...",
              "text-input-options": textInputOptions.value,
              format: FormatDatePicker,
              "text-input": "",
              "max-date": _unref(maxDate),
              teleport: true,
              required: ""
            }, null, 8, ["modelValue", "text-input-options", "max-date"])
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (ConfirmButtonAction())),
            disabled: selectedDate.value == undefined,
            class: "right-button"
          }, " Confirm ", 8, _hoisted_7)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})